import styled, { css } from 'styled-components';

const spacers = {
  spacers: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
  },
};

type StyledProps = { $rte?: boolean };

/**
 * Basic prose styles for rich text content
 */
function richTextStyles({ $rte }: StyledProps) {
  if (!$rte) return '';
  return css`
    > ul,
    > ol {
      // We use list-style-position: inside to help list items to look decent
      // when the text is center-aligned. However, there is a known bug in
      // Chromium which triples the margin after the ul li::marker. It is not
      // possible to override this ::marker style directly :-(
      list-style-position: inside;
      padding-inline-start: 0;

      & ul,
      & ol {
        padding-inline-start: 1.33em;
      }
    }

    ul {
      list-style-type: disc;
    }

    a,
    a:hover {
      text-decoration: underline;
    }

    > :last-child {
      margin-block-end: 0;
    }
  `;
}

export const Wrapper = styled.div<StyledProps>`
  margin-block-end: 0;
  padding-block-end: ${spacers?.spacers?.[1] ?? '0.25rem'};
  text-wrap: pretty;

  &.t-font-m,
  &.t-font-s,
  &.t-font-xs {
    line-height: 1.5;
  }

  ${richTextStyles}
`;
